/**
 * A centred dialog on a desktop, a bottom sheet on a phone (design D45–D53, mobile 42–51): add it
 * to a `DialogContent`'s classes. Below the desktop layout's width (48rem) the dialog spans the
 * screen's width, sits on its bottom edge and rounds its top corners only.
 */
export const SHEET_ON_PHONE =
  'max-md:top-auto max-md:bottom-0 max-md:left-0 max-md:max-w-full max-md:translate-x-0 max-md:translate-y-0 max-md:rounded-t-window max-md:rounded-b-none max-md:pb-[max(1.25rem,env(safe-area-inset-bottom))] max-md:data-[state=open]:slide-in-from-bottom-4';
